import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/consult';
import List from '../../List/List';
import {RECONSULT} from "../../../../../utility/variables";
import {resetStore} from "../../../../../redux/modules/login";


const ms2p = (state) => {
    return {
        ...state.consult,
        titulo: 'RECONSULTA',
        show_list: RECONSULT,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(List);
